// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"034dea34","787":"797bf9b4"}[chunkId] + ".chunk.js";
};